import { ZodSchema, ZodType, z } from 'zod';

const ZOD_DONT_PREPROCESS_STRING = Symbol('ZOD_DONT_PREPROCESS_STRING');

declare module 'zod' {
  interface ZodType {
    [ZOD_DONT_PREPROCESS_STRING]?: boolean;
  }
}

export function dontPreprocessStringForZod<T extends ZodType>(type: T): T {
  type[ZOD_DONT_PREPROCESS_STRING] = true;
  return type;
}

export const empty = (vals: string[], schema: ZodSchema = z.string().nullish()) => {
  const set = new Set(vals);
  return z.preprocess(v => (typeof v === 'string' && set.has(v) ? undefined : v), schema);
};
